export default "__VITE_ASSET__CjophSu6__"